import {ConsentPolicy} from '@wix/wix-bootstrap-api';

export function initConsentPolicyAndTagManagers(
  {
    baseUrl,
    consentPolicy,
    language,
  }: {
    baseUrl: string;
    consentPolicy?: ConsentPolicy;
    language: string;
  }
) {
  if (window.consentPolicyManager && window.consentPolicyManager.init) {
    window.consentPolicyManager.init({
      baseUrl,
      consentPolicy,
    });
  }

  if (window.wixTagManager && window.wixTagManager.init) {
    window.wixTagManager.init('RELEASE_NOTES', language);
  }
}
